/* eslint-disable react/no-unescaped-entities */
import React, { useState , useEffect} from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { avatar1, avatar13, avatar16, avatar18, avatar19, avatar2, avatar20, avatar21, avatar23, avatar26, avatar4, avatar6, avatar8, clockin, employeeimg, holidaycalendar } from "../../../../../Routes/ImagePath";
import Chart from "react-apexcharts";
import Slider from "react-slick";
import { ArrowRightCircle } from "react-feather";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getEmployeeHeadCount, getEmployeeStatstics, getEmployeeNationalityMix } from "api/services/dashboard";
import { SkeltonLoader } from "components/skeltonLoader";
import Image from "components/Image";
import {format} from "date-fns";
import dashBoardImage from "../../../../../assets/img/dash-city.png"
import EmployeeHeadcountChart from "./charts/EmployeeHeadCount";
import TotalEmployeesChart from "./charts/TotalEmployeesChart";
import EmployeesByDivisionChart from "./charts/EmployeesByDivisionChart";
import EmployeesByDepartmentChart from "./charts/EmployeesByDepartment";
import EmployeesByGenderChart from "./charts/EmployeesByGender";
import EmployeesByPositionChart from "./charts/EmployeeByPosition";
import EmployeeNationalityMix from "./charts/EmployeeNationalityMix";
import EmployeeCostCenter from "./charts/EmployeeCostCenter";
import NewEmployeesChart from "./charts/NewEmployeesChart";
import TerminationsChart from "./charts/TerminationsChart";
import GroupByCountChart from "./charts/groupbyCount";

const EmployeeStats = () => {

  const tooltip = (
      <Tooltip id="tooltip-id">
        Lesley Grauer
      </Tooltip>
    );
    const tooltip1 = (
      <Tooltip id="tooltip-id">
        Richard Miles
      </Tooltip>
    );
    const tooltip2 = (
      <Tooltip id="tooltip-id">
        Loren Gatlin
      </Tooltip>
    );
    const tooltip3 = (
      <Tooltip id="tooltip-id">
        Jeffery Lalor
      </Tooltip>
    );
    const tooltip4 = (
      <Tooltip id="tooltip-id">
        Tarah Shropshire
      </Tooltip>
    );
    const tooltip5 = (
      <Tooltip id="tooltip-id">
        Catherine Manseau
      </Tooltip>
    );
    const tooltip6 = (
      <Tooltip id="tooltip-id">
        Richard Miles
      </Tooltip>
    );
    const tooltip7 = (
      <Tooltip id="tooltip-id">
        Jeffery Lalor
      </Tooltip>
    );
    const tooltip8 = (
      <Tooltip id="tooltip-id">
        Lesley Grauer
      </Tooltip>
    );
    const tooltip9 = (
      <Tooltip id="tooltip-id">
        Loren Gatlin
      </Tooltip>
    );
    const tooltip10 = (
      <Tooltip id="tooltip-id">
        Tarah Shropshire
      </Tooltip>
    );
    const tooltip11 = (
      <Tooltip id="tooltip-id">
        John Smith"
      </Tooltip>
    );
    const tooltip12 = (
      <Tooltip id="tooltip-id">
        Richard Miles
      </Tooltip>
    );
    const tooltip13 = (
      <Tooltip id="tooltip-id">
        Jeffery Lalor
      </Tooltip>
    );
    const tooltip14 = (
      <Tooltip id="tooltip-id">
        Lesley Grauer
      </Tooltip>
    );
    const tooltip15 = (
      <Tooltip id="tooltip-id">
        Tarah Shropshire
      </Tooltip>
    );
    const tooltip16 = (
      <Tooltip id="tooltip-id">
      Loren Gatlin
      </Tooltip>
    );
 
  const [chartOptions] = useState({
    series: [
      {
        name: "Sales",
        data: [-50, -120, -80, -180, -80, -70, -100],
      },
      {
        name: "Purchase",
        data: [200, 250, 200, 290, 220, 300, 250],
      },
    ],
    colors: ['#FC133D', '#55CE63'],
    chart: {
      type: 'bar',
      height: 210,
      stacked: true,

      zoom: {
        enabled: true
      }
    },
    responsive: [
      {
        breakpoint: 280,
        options: {
          legend: {
            position: "bottom",
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 6,
        borderRadiusApplication: "end", // "around" / "end" 
        borderRadiusWhenStacked: "all", // "all"/"last"
        columnWidth: '30%',
        endingShape: 'rounded'
      },
    },
    dataLabels: {
      enabled: false,
    },
    yaxis: {
      min: -200,
      max: 300,
      tickAmount: 5,
    },
    xaxis: {
      categories: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S",

      ],
    },
    legend: { show: false },
    fill: {
      opacity: 1,
    },
  });

  const {
    user,
    userLoading
} = useSelector((state) => state.user);

const [employeeHeadCount, setEmployeeHeadCount] = useState([])
const [headCountLoading, setHeadCountLoading] = useState(true)

const [employeeStatstics, setEmployeeStatstics] = useState([])
const [employeeStatsticsLoading, setEmployeeStatsticsLoading] = useState(true)

const [employeeNationalityMix, setEmployeeNationalityMix] = useState([])
const [employeeNationlityMixLoading, setEmployeeNationlityMixLoading] = useState(true)

const [publicHoliday, setPublicHoliday] = useState([])
const [birthdays, setBirthDays] = useState([])
const [birthdayLoading, setBirthdayLoading] = useState(true)


const [anniversary, setAnniversary] = useState([])
const [anniversaryLoading, setAnniversaryLoading] = useState(true)


const [newJoiners, setnewJoiners] = useState([])
const [newJoinersLoading, setNewJoinersLoading] = useState(true)

const [terminated, setTerminated] = useState([])
const [terminatedLoading, setTerminatedLoading] = useState(true)

const [greeting, setGreeting] = useState("");

const [anniversaryFilter, setAnniversaryFilter] = useState("month")
const [birthdayFilter, setBirthdayFilter] = useState("month")


const [headCountSeries, setHeadCountSeries] = useState([])
const [headCountCategories, setHeadCountCategories] = useState([])

const [resignedHeadCount, setResignedHeadCount] = useState([])

const getHeadCountSeries = (res) => {
  const series = [
    {
        name: "Current Employees",
        data: res.map(item => item.current_employees)
    },
    {
        name: "New Employees",
        data: res.map(item => item.new_employees)
    },
    {
        name: "Attritions",
        data: res.map(item => item.terminations) 
    }
   
];
  return series
}

const getResignedHeadCountSeries = (res) => {
  const series = [
    {
      name: "Absconding",
      data: res.map(item => item.termination_reasons?.Absconding || 0)
    },
    {
      name: "Contract",
      data: res.map(item => item.termination_reasons?.Contract || 0)
    },
    {
      name: "Resign",
      data: res.map(item => item.termination_reasons?.Resign || 0)
    },
    {
      name: "Terminate",
      data: res.map(item => item.termination_reasons?.Terminate || 0)
    }
  ];
  return series;
}

const getHeadCountCategories = (res) => {
  const categories = res.map(item => new Date(item.month).toLocaleString('en-US', { month: 'short', year: 'numeric' }))
  // res.map(item => item.month)
  return categories
}
const fetchEmployeeHeadCount = () => {
  getEmployeeHeadCount().then(response=>{
    setEmployeeHeadCount(response.data)   
    setHeadCountSeries(getHeadCountSeries(response.data))
    setHeadCountCategories(getHeadCountCategories(response.data))
    setResignedHeadCount(getResignedHeadCountSeries(response.data))
    setHeadCountLoading(false)
  }).catch(()=>{
    setHeadCountLoading(false)
  })
}

const fetchEmployeeStatstics = () => {
  getEmployeeStatstics().then(response=>{
    setEmployeeStatstics(response.data)   
  
    setEmployeeStatsticsLoading(false)
  }).catch(()=>{
    setEmployeeStatsticsLoading(false)
  })
}

const fetchEmployeeNationalityMix = () => {
  getEmployeeNationalityMix().then(response=>{
    setEmployeeNationalityMix(response.data)   
    setEmployeeNationlityMixLoading(false)
  }).catch(()=>{
    setEmployeeNationlityMixLoading(false)
  })
}




const fetchData = () => {
 fetchEmployeeHeadCount();
 fetchEmployeeStatstics()
 fetchEmployeeNationalityMix();
}

useEffect(()=>{
  fetchData()

},[])

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    marginrigth: 10,
  };
  const settingsprojectslide = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,

  };

  const UserCard = () => {
    if(userLoading){
      return (
        <div className="card  flex-fill">
        <SkeltonLoader
                  number={1}
                  active={true}
                  className="col-lg-6 col-md-12 card w-100"
                />
                </div>
      )
      
    }
    return(
     <>
        
            {employeeStatstics?.grouped_by_division && 
            <EmployeesByDivisionChart divisions={employeeStatstics?.grouped_by_division}/>
          }
        </>
   
    )
  }


  useEffect(() => {
    const getGreeting = () => {
      const currentHour = new Date().getHours(); // Get the current hour (0-23)
      if (currentHour < 12) {
        return "Good Morning";
      } else if (currentHour < 18) {
        return "Good Afternoon";
      } else {
        return "Good Evening";
      }
    };

   setGreeting(getGreeting());
  }, []); // Empty dependency array ensures it runs only once when the component mounts

  
 
  
  
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid pb-0">
        
         
        <div className="row">
  {/* Employee Details */}
  <div className="col-lg-12 col-md-12">
    <div className="row">
      <div className="col-lg-4 col-md-6 col-sm-12">
        <div className="card bg-white shadow" style={{ height: "350px" }}>
          <div className="flex-fill">           
              {employeeStatstics?.total_employees && 
                <TotalEmployeesChart data={employeeStatstics?.grouped_by_employment_status}
                 activeEmployees={employeeStatstics?.total_active_employees} 
                 terminatedEmployees={employeeStatstics?.total_terminated_employees}
                  totalEmployees={employeeStatstics?.total_employees} 
                  resignedEmployees={employeeStatstics?.total_eos_pending_employees} />
              }
           
          </div>
        </div>
      </div>

     
      {/* <div className="col-md-6  col-sm-12">
              <div className="card main-card-bg-grey" >
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-sm-8">
                      <div className="statistic-header">
                        <h4>Employment Status</h4>
                      </div>
                  </div>
                    <div className="col-sm-4 text-sm-end">
                      <div className="owl-nav project-nav nav-control" />
                    </div>
                  </div>
                  {employeeStatstics?.grouped_by_department &&
            <GroupByCountChart data={employeeStatstics?.grouped_by_employment_status}/>
          }
                </div>
              </div>
            </div> */}

      <div className="col-md-5 col-sm-12">
        <div className="card bg-white shadow" style={{ height: "350px" }}>
          <div className="card-body ps-2 pt-2">
            <div className="row align-items-center">
              <div className="col-sm-12">
                <div className="statistic-header">
                  <h5 style={{ color: "#555" }}>Employee by Department Statistics</h5>
                </div>
              </div>
              <div className="col-sm-4 text-sm-end">
                <div className="owl-nav project-nav nav-control" />
              </div>
            </div>
            {employeeStatstics?.grouped_by_department &&
              <EmployeesByDepartmentChart departments={employeeStatstics?.grouped_by_department} />
            }
          </div>
        </div>
      </div>

      <div className="col-lg-3 col-md-6 col-sm-12">
        <div className="card bg-white shadow" style={{ minHeight: "350px" }}>
          <div className="card-body pt-2">
            <div className="row align-items-center">
              <div className="col-sm-12">
                <div className="statistic-header">
                  <h5 style={{ color: "#555" }}>Gender Distribution</h5>
                </div>
              </div>
              <div className="col-sm-4 text-sm-end">
                <div className="owl-nav project-nav nav-control" />
              </div>
            </div>
            {employeeStatstics?.grouped_by_gender && 
              <EmployeesByGenderChart genders={employeeStatstics?.grouped_by_gender} />
            }
          </div>
        </div>
      </div>
      {/* <div className="col-lg-3 col-md-6">
        <div className="card p-4 main-card-bg-grey">
          <div className="flex-fill">           
        
          {employeeStatstics?.grouped_by_department &&
            <EmployeesByDepartmentChart departments={employeeStatstics?.grouped_by_department} />
          }
          </div>
        </div>
      </div> */}
        
        {/* Add new chart later */}
      {/* <div className="col-lg-3 col-md-6">
        <div className="card p-4 main-card-bg-grey">
          <div className="flex-fill">           
            
           
          </div>
        </div>
      </div> */}

      {/* 

      <div className="col-lg-3 col-md-6">
        <UserCard />
      </div>

   

      <div className="col-lg-3 col-md-6">
        <div className="card flex-fill ">
          <div className="card-body">
            <h4>Additional Stats</h4>
            here
          </div>
        </div>
      </div> */}
    </div>
  </div>
</div>



    <div className="row">
          <div className="col-md-12">
              <div className="card bg-white shadow">
                <div className="card-body">
                <div className="col-sm-8">
                      <div className="statistic-header">
                        <h4>Nationality & Gender Distribution</h4>
                      </div>
                  </div>
                  {employeeNationalityMix && 
                 <EmployeeNationalityMix data={employeeNationalityMix} />
                  }
                  </div>
                  </div> </div>

               
          </div>


        


          <div className="row">
          <div className="col-md-12">
              <div className="card bg-white shadow">
                <div className="card-body">
                <div className="col-sm-8">
                      <div className="statistic-header">
                        <h4>Employee by Designation</h4>
                      </div>
                  </div>
                  {employeeStatstics?.grouped_by_position &&
                 <EmployeesByPositionChart positions={employeeStatstics?.grouped_by_position} />
                  }
                  </div>
                  </div> </div>
          </div>

          <div className="row">
          <div className="col-md-12">
              <div className="card bg-white shadow">
                <div className="card-body">
                <div className="col-sm-8">
                      <div className="statistic-header">
                        <h4>Cost Center Overview</h4>
                      </div>
                  </div>
                  {employeeStatstics?.cost_center && 
                <EmployeeCostCenter costCenters={employeeStatstics?.cost_center} />
              }
                  </div>
                  </div> 
                  </div>
          </div>

          
  {/* Employee Department */}
  <div className="row">
            {/* <div className="col-md-6">
              <div className="card main-card-bg-grey">
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-sm-8">
                      <div className="statistic-header">
                        <h4>Employee by Divison</h4>
                      </div>
                  </div>
                    <div className="col-sm-4 text-sm-end">
                      <div className="owl-nav project-nav nav-control" />
                    </div>
                  </div>
                  <UserCard />
                </div>
              </div>
            </div> */}

            {/* <div className="col-md-6">
              <div className="card main-card-bg-grey">
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-sm-8">
                      <div className="statistic-header">
                        <h4>Employee by Department</h4>
                      </div>
                  </div>
                    <div className="col-sm-4 text-sm-end">
                      <div className="owl-nav project-nav nav-control" />
                    </div>
                  </div>
                  {employeeStatstics?.grouped_by_department &&
            <EmployeesByDepartmentChart departments={employeeStatstics?.grouped_by_department} />
          }
                </div>
              </div>
            </div> */}

          </div>
          

   {/* Employee New Employees, Terminations */}
   <div className="row">
            <div className="col-md-6">
              <div className="card bg-white shadow">
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-sm-8">
                      <div className="statistic-header">
                        <h4>New Employees</h4>
                      </div>
                  </div>
                    <div className="col-sm-4 text-sm-end">
                      <div className="owl-nav project-nav nav-control" />
                    </div>
                  </div>
                  <NewEmployeesChart series={headCountSeries} categories={headCountCategories} />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card bg-white shadow">
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-sm-8">
                      <div className="statistic-header">
                        <h4>Resigned/Terminated/Non-Renewal</h4>
                      </div>
                  </div>
                    <div className="col-sm-4 text-sm-end">
                      <div className="owl-nav project-nav nav-control" />
                    </div>
                  </div>
                  <TerminationsChart series={resignedHeadCount} categories={headCountCategories} />
                </div>
              </div>
            </div>
          </div>


          {/* Employee Head Count */}
          <div className="row">
            <div className="col-md-12">
              <div className="card bg-white shadow">
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-sm-8">
                      <div className="statistic-header">
                        <h4>Employee Head Count</h4>
                      </div>
                  </div>
                    <div className="col-sm-4 text-sm-end">
                      <div className="owl-nav project-nav nav-control" />
                    </div>
                  </div>
                  <EmployeeHeadcountChart series={headCountSeries} categories={headCountCategories} />
                </div>
              </div>
            </div>
          </div>
    


          <div className="row" >
          <div className="col-xl-6 col-md-12 d-flex">
            
            </div>

            <div className="col-xl-6 col-md-12 d-flex">
            _
            </div>

          </div>

         
        </div>
        {/* /Page Content */}
      </div>
      {/* /Page Wrapper */}
    </>

  );
};

export default EmployeeStats;
